export default "__VITE_ASSET__BVKnL5Hg__"